import { AxiosResponse } from "axios";
import { pushGlobalError } from "../../../errors/globalError";
import { getDispositionFilename } from "../../../utils/downloadBlob";

export const DISPATCH_PDF_ERROR = "ไม่สามารถเปิดไฟล์ PDF ได้ กรุณาลองใหม่อีกครั้ง";

/** A failure with an HTTP status already has its message from the interceptor. */
const handledByInterceptor = (error: unknown) =>
  typeof (error as { response?: { status?: number } } | null)?.response?.status === "number";

export const asPdf = (raw: unknown): Blob => {
  if (!(raw instanceof Blob) || raw.size === 0 || raw.type.includes("application/json")) {
    throw new Error("Invalid PDF file response");
  }
  return new Blob([raw], { type: "application/pdf" });
};

export type PdfMode = "open" | "download";

/**
 * Fetch the PDF through the authenticated client, then open it in a new tab (the browser's viewer
 * prints it) or save it under the server's filename. The tab is opened synchronously inside the
 * click so popup blockers let it through. Returns whether the PDF arrived.
 */
export async function deliverPdf(
  mode: PdfMode,
  fetchPdf: () => Promise<AxiosResponse<Blob>>,
  fallbackName: string,
): Promise<boolean> {
  const tab = mode === "open" ? window.open("", "_blank") : null;
  try {
    const response = await fetchPdf();
    const blob = asPdf(response.data);
    const url = URL.createObjectURL(blob);
    if (mode === "open") {
      if (tab) tab.location.href = url;
      else window.open(url, "_blank", "noopener");
    } else {
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        getDispositionFilename(response.headers?.["content-disposition"] as string | undefined, fallbackName),
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
    }
    setTimeout(() => URL.revokeObjectURL(url), 60_000);
    return true;
  } catch (error) {
    if (tab) tab.close();
    if (!handledByInterceptor(error)) pushGlobalError(DISPATCH_PDF_ERROR);
    return false;
  }
}
